import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import moment from 'moment/moment'
import { COURSE_IDS } from "../student/lessonsSlice"

interface StudentContentStatus {
  status: string
  completedOn: string | null
}

export interface TeacherStudent {
  id: number | string
  firstName: string
  lastName: string
  validated: boolean
  hasLoggedInToNativeApp: boolean
  classroomId: number | string
  lessons: StudentContentStatus[]
  dailyBeats: StudentContentStatus[]
  emailAddress: string
  validationToken: string | null
  exampleStudent: boolean
  coursePoints: number
  mheCoursePoints?: number
  totalCoursePoints: number
}

export const selectStudentsByClassroomId = (classroomId: number | string) => (state: any) => state.students.filter((student: TeacherStudent) => student.classroomId === classroomId)
export const selectNumValidatedStudentsByClassroomId = (classroomId: number | string) => (state: any) => state.students.filter((student: TeacherStudent) => student.classroomId === classroomId && student.validated).length
export const selectStudentById = (studentId: number | string) => (state: any) => state.students.find((student: TeacherStudent) => student.id === studentId)

export const exampleStudents = [
  {
    id: 'example-active-1',
    firstName: 'Student',
    lastName: 'A',
    validated: true,
    hasLoggedInToNativeApp: true,
    classroomId: 'example-active-class',
    lessons: [
      // FoF
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '1XSdSU0cn9dMQ3tOzN0XXR', lessonNumer: 1, status: 'completed', completedOn: moment().subtract(4, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '6f2qYUSQveiWkiI0Ku2qW', lessonNumer: 2, status: 'completed', completedOn: moment().subtract(3, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '2bf35cxuLaWOOiGKCiUOaC', lessonNumer: 3, status: 'in progress', completedOn: null },
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '6r1GVXlcQ0GQeugkmK0YKI', lessonNumer: 4, status: 'not started', completedOn: null },
      // MHE
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '1at81dSi6XWq0RAeNRzYna', lessonNumer: 1, status: 'completed', completedOn: moment().subtract(4, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '9iJHaYnNgLWlr3afp57W0', lessonNumer: 2, status: 'completed', completedOn: moment().subtract(3, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '2NFi98euaU5LnGBCR5UciS', lessonNumer: 3, status: 'completed', completedOn: moment().subtract(2, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '4eqJmCViBe2tl6A442dI5Q', lessonNumer: 4, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '3OZEoY791gZDfVoadCo8eR', lessonNumer: 5, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: 'K7nf0aMaTly4YYmtiL7ol', lessonNumer: 6, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: 'xWgceJZYPqkYz2MU7KPvi', lessonNumer: 7, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '2eH4VqewQYm08Ccd152RFE', lessonNumer: 8, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '20POZmc76W6k4WvTKRflid', lessonNumer: 9, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '7yuOlguNVseFqcLex8m5Xw', lessonNumer: 10, status: 'not started', completedOn: null },
    ],
    dailyBeats: [],
    emailAddress: 'studenta@gmail.com',
    validationToken: null,
    exampleStudent: true,
    coursePoints: 50,
    mheCoursePoints: 30,
    totalCoursePoints: 100,
  },
  {
    id: 'example-active-2',
    firstName: 'Student',
    lastName: 'B',
    validated: true,
    hasLoggedInToNativeApp: true,
    classroomId: 'example-active-class',
    lessons: [
      // FoF
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '1XSdSU0cn9dMQ3tOzN0XXR', lessonNumer: 1, status: 'completed', completedOn: moment().subtract(3, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '6f2qYUSQveiWkiI0Ku2qW', lessonNumer: 2, status: 'completed', completedOn: moment().subtract(2, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '2bf35cxuLaWOOiGKCiUOaC', lessonNumer: 3, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '6r1GVXlcQ0GQeugkmK0YKI', lessonNumer: 4, status: 'not started', completedOn: null },
      // MHE
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '1at81dSi6XWq0RAeNRzYna', lessonNumer: 1, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '9iJHaYnNgLWlr3afp57W0', lessonNumer: 2, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '2NFi98euaU5LnGBCR5UciS', lessonNumer: 3, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '4eqJmCViBe2tl6A442dI5Q', lessonNumer: 4, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '3OZEoY791gZDfVoadCo8eR', lessonNumer: 5, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: 'K7nf0aMaTly4YYmtiL7ol', lessonNumer: 6, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: 'xWgceJZYPqkYz2MU7KPvi', lessonNumer: 7, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '2eH4VqewQYm08Ccd152RFE', lessonNumer: 8, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '20POZmc76W6k4WvTKRflid', lessonNumer: 9, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '7yuOlguNVseFqcLex8m5Xw', lessonNumer: 10, status: 'not started', completedOn: null },
    ],
    dailyBeats: [],
    emailAddress: 'studentb@gmail.com',
    validationToken: null,
    exampleStudent: true,
    coursePoints: 75,
    mheCoursePoints: 0,
    totalCoursePoints: 100,
  },
  {
    id: 'example-active-3',
    firstName: 'Student',
    lastName: 'C',
    validated: true,
    hasLoggedInToNativeApp: true,
    classroomId: 'example-active-class',
    lessons: [
      // FoF
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '1XSdSU0cn9dMQ3tOzN0XXR', lessonNumer: 1, status: 'completed', completedOn: moment().subtract(3, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '6f2qYUSQveiWkiI0Ku2qW', lessonNumer: 2, status: 'completed', completedOn: moment().subtract(2, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '2bf35cxuLaWOOiGKCiUOaC', lessonNumer: 3, status: 'completed', completedOn: moment().format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '6r1GVXlcQ0GQeugkmK0YKI', lessonNumer: 4, status: 'not started', completedOn: null },
      // MHE
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '1at81dSi6XWq0RAeNRzYna', lessonNumer: 1, status: 'completed', completedOn: moment().subtract(5, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '9iJHaYnNgLWlr3afp57W0', lessonNumer: 2, status: 'completed', completedOn: moment().subtract(4, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '2NFi98euaU5LnGBCR5UciS', lessonNumer: 3, status: 'completed', completedOn: moment().subtract(3, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '4eqJmCViBe2tl6A442dI5Q', lessonNumer: 4, status: 'in progress', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '3OZEoY791gZDfVoadCo8eR', lessonNumer: 5, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: 'K7nf0aMaTly4YYmtiL7ol', lessonNumer: 6, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: 'xWgceJZYPqkYz2MU7KPvi', lessonNumer: 7, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '2eH4VqewQYm08Ccd152RFE', lessonNumer: 8, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '20POZmc76W6k4WvTKRflid', lessonNumer: 9, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '7yuOlguNVseFqcLex8m5Xw', lessonNumer: 10, status: 'not started', completedOn: null },
    ],
    dailyBeats: [],
    emailAddress: 'studentc@gmail.com',
    validationToken: null,
    exampleStudent: true,
    coursePoints: 75,
    mheCoursePoints: 30,
    totalCoursePoints: 100,
  },
  {
    id: 'example-active-4',
    firstName: 'Student',
    lastName: 'D',
    validated: true,
    hasLoggedInToNativeApp: true,
    classroomId: 'example-active-class',
    lessons: [
      // FoF
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '1XSdSU0cn9dMQ3tOzN0XXR', lessonNumer: 1, status: 'completed', completedOn: moment().subtract(3, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '6f2qYUSQveiWkiI0Ku2qW', lessonNumer: 2, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '2bf35cxuLaWOOiGKCiUOaC', lessonNumer: 3, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.FOUNDATIONS_OF_FOCUS, id: '6r1GVXlcQ0GQeugkmK0YKI', lessonNumer: 4, status: 'not started', completedOn: null },
      // MHE
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '1at81dSi6XWq0RAeNRzYna', lessonNumer: 1, status: 'completed', completedOn: moment().subtract(5, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '9iJHaYnNgLWlr3afp57W0', lessonNumer: 2, status: 'completed', completedOn: moment().subtract(4, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '2NFi98euaU5LnGBCR5UciS', lessonNumer: 3, status: 'completed', completedOn: moment().subtract(3, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '4eqJmCViBe2tl6A442dI5Q', lessonNumer: 4, status: 'completed', completedOn: moment().subtract(2, 'days').format('YYYY-MM-DD') },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '3OZEoY791gZDfVoadCo8eR', lessonNumer: 5, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: 'K7nf0aMaTly4YYmtiL7ol', lessonNumer: 6, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: 'xWgceJZYPqkYz2MU7KPvi', lessonNumer: 7, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '2eH4VqewQYm08Ccd152RFE', lessonNumer: 8, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '20POZmc76W6k4WvTKRflid', lessonNumer: 9, status: 'not started', completedOn: null },
      { courseId: COURSE_IDS.MENTAL_HEALTH_ESSENTIALS, id: '7yuOlguNVseFqcLex8m5Xw', lessonNumer: 10, status: 'not started', completedOn: null },
    ],
    dailyBeats: [],
    emailAddress: 'studentd@gmail.com',
    validationToken: null,
    exampleStudent: true,
    coursePoints: 25,
    mheCoursePoints: 40,
    totalCoursePoints: 100,
  },
]

const initialState: TeacherStudent[] = []

const studentsSlice = createSlice({
  name: 'students',
  initialState,
  reducers: {
    loadStudents: (state, {
      payload: students,
    }: PayloadAction<any[]>) => {
      const mappedStudents = students.map((student: any) => ({
        id: student.id,
        firstName: student.firstName,
        lastName: student.lastName,
        validated: student.validated,
        hasLoggedInToNativeApp: student.hasLoggedInToNativeApp,
        classroomId: student.classroomId,
        lessons: student.lessons,
        dailyBeats: student.dailyBeats,
        emailAddress: student.emailAddress,
        validationToken: student.validationToken,
        exampleStudent: false,
        coursePoints: student.coursePoints,
        mheCoursePoints: student.mheCoursePoints,
        totalCoursePoints: student.totalCoursePoints,
      }))
      return mappedStudents
    },
    refreshSomeStudents: (state, { payload: studentsToUpdate }: PayloadAction<any[]>) => {
      if (studentsToUpdate.length === 0) return

      // create a map of the students to update for quick lookup
      const studentsToUpdateMap = new Map(studentsToUpdate.map(student => [student.id, student]))

      // update the state with the new student data
      studentsToUpdate.forEach((student) => {
        const existingStudentIndex = state.findIndex((s) => s.id === student.id)
        if (existingStudentIndex !== -1) {
          // Update existing student
          state[existingStudentIndex] = {
              ...state[existingStudentIndex],
              ...(studentsToUpdateMap.get(student.id) || {}),
          }
        } else {
          // Add new student if not found
          state.push({
            ...student,
            exampleStudent: false,
          })
        }
      })
    },
    addNewStudent: (state, { payload: newStudent }: PayloadAction<any>) => {
      const existingStudentIndex = state.findIndex((s) => s.id === newStudent.id)
      if (existingStudentIndex !== -1) return

      state.push({ ...newStudent, exampleStudent: false })
    }
  },
})

export const { loadStudents, refreshSomeStudents, addNewStudent } = studentsSlice.actions

export default studentsSlice.reducer
